export interface RunCodeResultData {
  success: boolean
  output?: unknown
  stdout?: string
  error?: string
  traceback?: string
}

export function isRunCodeResult(value: unknown): value is RunCodeResultData {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'success' in value &&
      typeof (value as { success: unknown }).success === 'boolean'
  )
}

interface RunCodeResultProps {
  result: RunCodeResultData
}

export function RunCodeResult({ result }: RunCodeResultProps) {
  return (
    <div className="space-y-2">
      <div className="text-xs text-gray-700">
        {result.success ? (
          <span className="text-green-600 font-medium">
            ✓ Code executed successfully
          </span>
        ) : (
          <span className="text-red-600 font-medium">
            ✗ Code execution failed
          </span>
        )}
      </div>
      {result.stdout && (
        <div>
          <div className="text-xs font-semibold text-gray-600 mb-1">
            Output:
          </div>
          <pre className="text-xs text-gray-700 bg-gray-100 rounded p-2 whitespace-pre-wrap break-words">
            {result.stdout}
          </pre>
        </div>
      )}
      {result.success &&
        result.output !== undefined &&
        result.output !== null && (
          <div>
            <div className="text-xs font-semibold text-gray-600 mb-1">
              Return Value:
            </div>
            <pre className="text-xs text-gray-700 bg-gray-100 rounded p-2 whitespace-pre-wrap break-words break-all">
              {typeof result.output === 'string'
                ? result.output
                : JSON.stringify(result.output, null, 2)}
            </pre>
          </div>
        )}
      {!result.success && result.error && (
        <div>
          <div className="text-xs font-semibold text-red-600 mb-1">Error:</div>
          <pre className="text-xs text-red-700 bg-red-50 rounded p-2 whitespace-pre-wrap break-words">
            {result.error}
          </pre>
        </div>
      )}
      {!result.success && result.traceback && (
        <div>
          <div className="text-xs font-semibold text-red-600 mb-1">
            Traceback:
          </div>
          <pre className="text-xs text-red-600 bg-red-50 rounded p-2 whitespace-pre-wrap break-words font-mono">
            {result.traceback}
          </pre>
        </div>
      )}
    </div>
  )
}
